import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Field, FieldLabel } from "@akuna/ui";
import { Autocomplete } from "@/components/ui/autocomplete";
import { usePatientSearchForQuickStart, type PatientSearchOption } from "@/hooks/usePatientSearchForQuickStart";
import { PatientSearchResult } from "../PatientSearchResult";

export function ReservationPetPicker({ value, onSelect }: { value: PatientSearchOption | null; onSelect: (option: PatientSearchOption | null) => void }) {
  const { t } = useTranslation("daycareHotel");
  const [search, setSearch] = useState("");
  const { data = [], isFetching } = usePatientSearchForQuickStart(search);
  const byValue = new Map(data.map((option) => [option.value, option]));
  const options = data.map((option) => ({ value: option.value, label: option.label }));

  return (
    <Field>
      <FieldLabel>{t("petAndOwner")}</FieldLabel>
      {value ? (
        <div className="flex items-center gap-3 rounded-xl border border-border bg-card p-3">
          <PatientSearchResult option={value} variant="selected" petHref={`/patients/pets/${value.petId}/overview`} onRemove={() => { onSelect(null); setSearch(""); }} />
        </div>
      ) : (
        <Autocomplete
          value={search}
          options={options}
          onChange={setSearch}
          onSelect={(option) => { const selected = byValue.get(option.value) ?? null; onSelect(selected); setSearch(""); }}
          disableLocalFilter
          popoverPortalled={false}
          placeholder={t("searchPetOwner")}
          emptyMessage={isFetching ? t("loading") : t("noPetsFound")}
          renderOption={(option) => {
            const selected = byValue.get(option.value);
            return selected ? <PatientSearchResult option={selected} variant="option" /> : <span>{option.label}</span>;
          }}
        />
      )}
    </Field>
  );
}
